import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AlertController, Platform } from '@ionic/angular';
import { environment } from 'src/environments/environment';
import { App } from '@capacitor/app';
import { Browser } from '@capacitor/browser';
@Injectable({
  providedIn: 'root'
})
export class VersionCheck {
  // URL de tu endpoint creado en el Paso 2
   private  url=environment.url;

  constructor(
    private http: HttpClient,
    private plt: Platform,
    private alertCtrl: AlertController
  ) { }

  async checkForUpdate() {
    // 1. Obtener la versión instalada actual

  if (!this.plt.is('hybrid')) {
          console.log('Estamos en Web: Se omite el chequeo de versión nativa.');
          return;
      }
      // 2. Si es Android/iOS, continuamos normalmente
    try {
        const info = await App.getInfo();
        const versionActual = info.version;
  //  console.log('Version actual instalada:', versionActual);
       this.http.get(this.url+'version-check').subscribe(async (res: any) => {
      

        // console.log('Respuesta del servidor para version-check:', res.android);
      let dataServidor = null;

      // Detectamos la plataforma para leer los datos correctos
      if (this.plt.is('android')) {
        dataServidor = res.android;
      } else if (this.plt.is('ios')) {
        dataServidor = res.ios;
      }

      if (dataServidor) {
        // 3. Comparar versiones
        // console.log('Datos de versión del servidor:', JSON.stringify(dataServidor, null, 2));
        console.log('Version recibida del servidor:', dataServidor.version);
        // console.log('URL de actualización recibida:', dataServidor.url);
        const hayNueva = this.compararVersiones(versionActual, dataServidor.version);
        //  console.log('¿Hay una nueva versión disponible?', hayNueva);
        if (hayNueva) {
          this.presentUpdateAlert(dataServidor.url, dataServidor.force_update, dataServidor.version);
        }
      }
    });
    } catch (error) {
        console.error('Error al obtener info de la app:', error);
    }
  //   console.log('Checking for app version updates...');
  //   const info = await App.getInfo();
  //   const versionActual = info.version; // Ej: "1.0.0"
  //  console.log('Version actual instalada:', versionActual);
    // 2. Consultar al servidor
   
  }

  // Lógica para comparar "1.0.2" contra "1.0.5"
  private compararVersiones(vActual: string, vNueva: string): boolean {
    const actual = vActual.split('.').map(Number);
    const nueva = vNueva.split('.').map(Number);

    for (let i = 0; i < Math.max(actual.length, nueva.length); i++) {
      const valActual = actual[i] || 0;
      const valNueva = nueva[i] || 0;

      if (valNueva > valActual) return true; // La nueva es mayor
      if (valNueva < valActual) return false; // La actual es mayor (downgrade)
    }
    return false; // Son iguales
  }

  async presentUpdateAlert(storeUrl: string, force: boolean, version: string) {
    const alert = await this.alertCtrl.create({
      header: '¡Nueva Versión Disponible!',
      // message: `La versión  ya está disponible con mejoras y correcciones.`,
      backdropDismiss: !force, // Si es forzoso, no pueden tocar fuera para cerrar${version}
      buttons: [
        {
          text: 'Ahora no',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
             // Si es forzoso, devolvemos false para que NO se cierre el alert
             return !force; 
          }
        }, 
        {
          text: 'Actualizar',
          handler: () => {
            // Abrir la tienda
            Browser.open({ url: storeUrl });
            return false; // No cerrar el alert para que actualicen sí o sí (opcional)
          }
        }
      ]
    });

    // Si la actualización es obligatoria, quitamos el botón de cancelar
    if (force) {
        alert.buttons = alert.buttons.filter((b:any) => b.text !== 'Ahora no');
    }

    await alert.present();
  }
}
